import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button } from '@ontruck/orc';
import PodUpload from 'components/PodUpload';

const PodModal = ({
  className,
  stops,
  cargo_manifest,
  addFuctionToUpload,
  uploadFiles,
  closeModal,
  disabled,
  removeUrlToSend
}) => {
  const { t } = useTranslation('Pods');
  const [error, setError] = useState(false);
  return (
    <div className={className} data-testid="pod-modal">
      <div className="pod-modal">
        <div className="pod-modal__header">
          <div className="pod-modal__title">{t('uploadAction')}</div>
          <div className="pod-modal__subtitle">{t('fileDescription')}</div>
        </div>
        <div className="pod-modal__body">
          {cargo_manifest.map((manifest, index) => {
            if (
              stops[manifest.destination_stop]?.status !==
              'DONE_WITHOUT_MANIFEST'
            )
              return null;
            return (
              <PodUpload
                key={`stop-${index}`}
                manifest={manifest}
                title={stops[manifest.destination_stop]?.address?.company_name}
                addFuctionToUpload={addFuctionToUpload}
                toggleError={setError}
                removeUrlToSend={removeUrlToSend}
              />
            );
          })}
        </div>
        <div className="pod-modal__footer">
          <Button
            data-testid="pod-modal__button-cancel"
            className="pod-modal__button"
            skin="primary"
            ghost
            text={t('cancelAction')}
            onClick={closeModal}
          />
          <Button
            data-testid="pod-modal__button-upload"
            className="pod-modal__button"
            skin="primary"
            text={t('uploadActionPlural')}
            onClick={uploadFiles}
            disabled={error || disabled}
          />
        </div>
      </div>
    </div>
  );
};
PodModal.propTypes = {
  className: PropTypes.string,
  addFuctionToUpload: PropTypes.func.isRequired,
  removeUrlToSend: PropTypes.func.isRequired,
  uploadFiles: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  stops: PropTypes.array.isRequired,
  cargo_manifest: PropTypes.array.isRequired,
  disabled: PropTypes.bool.isRequired
};
export default PodModal;
